import { app } from '../../../../../app';
import { Controller } from './directory-manage-configuration.controller';

app.component('companyDirectoryIntegrationManageConfiguration', {
    bindings: {
        companyId: '<',
        directory: '<',
        domains: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-configuration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/configuration/directory-manage-configuration.component.js